<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#0F285B"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M16.0291 12.0207C16.0291 12.206 15.9673 12.3912 15.813 12.5764C14.6397 13.7496 13.4356 14.9537 12.2623 16.1269C11.5521 16.837 10.4715 15.7564 11.1816 15.0463C11.9535 14.2745 12.6945 13.5335 13.4664 12.7617C9.23649 12.7617 4.97568 12.7617 0.745739 12.7617C0.560487 12.7617 0.375234 12.6999 0.282608 12.6073C0.0973549 12.4838 -0.0261471 12.2677 0.00472838 11.9899C0.0973547 7.76022 2.22776 3.83932 5.90194 1.64732C12.571 -2.3662 21.5558 1.30771 23.5936 8.84078C25.6314 16.4665 19.7341 23.8452 11.9844 23.9995C10.9964 24.0304 10.9964 22.4868 11.9844 22.4559C16.2452 22.3633 20.1355 19.8625 21.7102 15.8799C23.2539 12.0207 22.2968 7.51324 19.3945 4.58028C16.4613 1.64732 11.9535 0.721122 8.0941 2.26478C4.35817 3.7467 1.88813 7.29712 1.5485 11.218C5.50056 11.218 9.42174 11.218 13.3738 11.218C12.6019 10.4462 11.8609 9.70524 11.089 8.9334C10.3789 8.22332 11.4904 7.14276 12.1697 7.85284C13.3738 9.0569 14.5779 10.261 15.813 11.4959C15.9673 11.6503 16.0291 11.8355 16.0291 12.0207Z"
    />
  </svg>
</template>
